module.exports = __webpack_public_path__ + "static/media/help1.d68b5b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/help1.png
// module id = 1497
// module chunks = 10